import React from 'react';
import TruncatedCell from '../../components/TruncatedCell';
import Pagination from '../../components/Pagination';

const ActivitiesTab = ({
    meetings,
    handleMeetingClick,
    handleOpenModal,
    meetingsPage,
    setMeetingsPage,
    meetingsTotalPages,
    meetingsTotal,
    meetingsPerPage
}) => {
    return (
        <React.Fragment>
            <div className="activities-tab-actions">
                <button className="modal-button-confirm" onClick={handleOpenModal}>
                    + 活動追加
                </button>
            </div>

            <div className="table-responsive">
                {meetings && meetings.length > 0 ? (
                    <table>
                        <thead>
                            <tr>
                                <th>活動名</th>
                                <th>担当者</th>
                                <th>活動日</th>
                            </tr>
                        </thead>
                        <tbody>
                            {meetings.map((meeting) => (
                                <tr
                                    key={meeting.id}
                                    className="clickable-row"
                                    onClick={() => handleMeetingClick(meeting.id)}
                                >
                                    <td>
                                        <TruncatedCell text={meeting.name} maxLength={25} />
                                    </td>
                                    <td>{meeting.owner_name}</td>
                                    <td>{meeting.meeting_date}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ) : (
                    <p className="no-data">活動履歴がありません。</p>
                )}
            </div>

            {meetingsTotalPages > 0 && (
                <Pagination
                    currentPage={meetingsPage}
                    totalPages={meetingsTotalPages}
                    totalItems={meetingsTotal}
                    perPage={meetingsPerPage}
                    onPageChange={setMeetingsPage}
                />
            )}
        </React.Fragment>
    );
};

export default ActivitiesTab;
